import { render, staticRenderFns } from "./eventReportCO.vue?vue&type=template&id=5b3e6b0c&scoped=true"
import script from "./eventReportCO.vue?vue&type=script&lang=js"
export * from "./eventReportCO.vue?vue&type=script&lang=js"
import style0 from "./eventReportCO.vue?vue&type=style&index=0&id=5b3e6b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e6b0c",
  null
  
)

export default component.exports